/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import useStyles from './styles';
import clsx from 'clsx';
import { pushToGtm } from '../../utils/datalayer';

const Page = props => {
  const { title, children, fullHeight, ...rest } = props;
  const classes = useStyles();
  const location = useLocation();

  useEffect(() => {
    pushToGtm('PageLoaded');
  }, [title, location]);

  return (
    <div className={clsx(classes.root, fullHeight && classes.fullHeight)} {...rest}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </div>
  );
};

Page.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

export default Page;
